import { InfoIcon } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

export const InfoDialog = ({
  show,
  onClose,
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
  canCancel,
  canClose,
}: {
  show: boolean;
  onClose: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  canCancel?: boolean;
  canClose?: boolean;
}) => {
  const isAlert = canCancel === false || canClose === false;

  if (isAlert) {
    return (
      <AlertDialog open={show} onOpenChange={onClose}>
        <AlertDialogContent className="max-w-full md:max-w-lg">
          <AlertDialogHeader className="flex flex-row flex-wrap gap-4 items-center space-y-0">
            <InfoIcon className="text-primary" size={24} />
            <AlertDialogTitle className="font-medium tracking-tighter my-0">
              {title}
            </AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogDescription className="whitespace-pre-line">
            {description}
          </AlertDialogDescription>

          <AlertDialogFooter>
            {canCancel && (
              <Button variant="outline" onClick={onClose}>
                {cancelText ?? "Cancel"}
              </Button>
            )}
            {canClose && (
              <Button variant={"default"} onClick={onConfirm}>
                {confirmText ?? "Confirm"}
              </Button>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    );
  }
  return (
    <Dialog open={show} onOpenChange={onClose}>
      <DialogContent className="max-w-full md:max-w-lg">
        <DialogHeader className="flex flex-row gap-4 items-center space-y-0">
          <InfoIcon className="text-primary" size={24} />
          <DialogTitle className="font-medium tracking-tighter my-0">
            {title}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="whitespace-pre-line">
          {description}
        </DialogDescription>

        <DialogFooter>
          {canCancel && (
            <Button variant="outline" onClick={onClose}>
              {cancelText ?? "Cancel"}
            </Button>
          )}
          <Button variant={"default"} onClick={onConfirm}>
            {confirmText ?? "Confirm"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
